import { Link } from "wouter";
import { useLocale, type Locale } from "@/lib/locale";

const copy: Record<Locale, { title: string; needs: string; labels: string[] }> = {
  it: { title: "Soluzioni per tipo di struttura", needs: "Funzioni per esigenza", labels: ["Campeggi", "Aree sosta camper", "Agricampeggi", "Glamping"] },
  en: { title: "Solutions by property type", needs: "Features by operational need", labels: ["Campsites", "RV parks", "Farm campsites", "Glamping sites"] },
  de: { title: "Lösungen nach Betriebsart", needs: "Funktionen nach Bedarf", labels: ["Campingplätze", "Wohnmobilstellplätze", "Camping auf dem Bauernhof", "Glamping-Anlagen"] },
  hr: { title: "Rješenja prema vrsti objekta", needs: "Funkcije prema potrebama", labels: ["Kampovi", "Kamp odmorišta", "Kampovi na seoskim imanjima", "Glamping objekti"] },
};
const paths = ["/", "/gestionale-aree-sosta-camper", "/gestionale-agricampeggi", "/gestionale-glamping"];

export function StructureNavigation() {
  const { locale } = useLocale();
  const c = copy[locale];
  return <div className="mb-5 min-w-0">
    <h2 className="mb-3 text-sm font-bold text-primary">{c.title}</h2>
    <ul className="grid grid-cols-2 gap-2 xl:grid-cols-4">
      {paths.map((href, i) => <li key={href} className="min-w-0">
        <Link href={href} className="block rounded-xl border border-primary/10 bg-primary/[0.025] px-3 py-3 text-sm font-semibold text-primary transition-colors hover:bg-primary/10">{c.labels[i]}</Link>
      </li>)}
    </ul>
    <h2 className="mt-5 text-sm font-bold text-primary">{c.needs}</h2>
  </div>;
}
